import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { AutoplayButton } from "../AutoplayButton/index.js";
import { PAGINATION_DOTS_TEST_ID } from "./constants.js";
import { NavigationButtonBottomAlignContainer, PaginationDotsWrapper } from "./styles.js";
import { NavigationButton } from "../NavigationButton/index.js";
import { PaginationDots } from "../PaginationDots/index.js";
const LowerControls = ({
  carousel,
  contentTypeLabel,
  contentTypeJoinder,
  isActive,
  isAutoplay,
  isVisible,
  handleAutoplayClick,
  nextButtonProps,
  onButtonAutoplayClick,
  onButtonBlur,
  onButtonFocus,
  pauseLabel,
  playLabel,
  previousButtonProps,
  scrollSnaps,
  selectedIndex
}) => {
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center"
      },
      children: [
        /* @__PURE__ */ jsx(NavigationButtonBottomAlignContainer, { children: /* @__PURE__ */ jsx(NavigationButton, { ...previousButtonProps }) }),
        scrollSnaps.length > 1 && /* @__PURE__ */ jsxs(PaginationDotsWrapper, { "data-testid": PAGINATION_DOTS_TEST_ID, children: [
          /* @__PURE__ */ jsx(
            PaginationDots,
            {
              carousel,
              contentTypeJoinder,
              contentTypeLabel,
              onButtonAutoplayClick,
              onButtonFocus,
              onButtonBlur,
              scrollSnaps,
              selectedIndex
            }
          ),
          /* @__PURE__ */ jsx(
            AutoplayButton,
            {
              enabled: isAutoplay,
              handleAutoplayClick,
              isActive,
              onButtonFocus,
              onButtonBlur,
              pauseLabel,
              playLabel
            }
          )
        ] }),
        /* @__PURE__ */ jsx(NavigationButtonBottomAlignContainer, { children: /* @__PURE__ */ jsx(NavigationButton, { ...nextButtonProps }) })
      ]
    }
  );
};
export {
  LowerControls
};
